import { QueryClient } from '@tanstack/react-query';
import type { ReactProcedureContext } from '@epihub/web/src/procedure';
import {
  buildUseQueryProcedure,
  buildUseSuspendedQueryProcedure,
  buildUseMutationProcedure,
} from '@epihub/web/src/procedure';
import { getHTTPProtocol } from '@epihub/core/src/process/protocols';
import { getAppDomains } from '@krishanmadan/core/src/_ctx/vars';
import { useGlobalStore } from '../store/useGlobalStore';

export const queryClient = new QueryClient();

export const useReactQueryContext = (): ReactProcedureContext => {
  return {
    baseURL: `${getHTTPProtocol()}//${getAppDomains().backend}/user`,
    credentials: 'include',
    headers: {
      ['x-visitor-id']: useGlobalStore.getState().settings.visitorId,
    },
  };
};

export const useQueryProcedure = buildUseQueryProcedure(useReactQueryContext);
export const useSuspendedQueryProcedure = buildUseSuspendedQueryProcedure(useReactQueryContext);
export const useMutationProcedure = buildUseMutationProcedure(useReactQueryContext);
